import Request from "../handleRequest/Request";
const api = "api/packages";
function toQueryStrings(params) {
  return "?" + Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join('&')
}
export default {
  async list(filter) {

    return await Request.get(api, toQueryStrings(filter))
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
  tracking(id) {
    return Request.get("api/packages/track/", id)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },

  add(data) {
    return Request.post(api, data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
  report(data) {
    return Request.post("api/package/report", data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
  checkBlackList(data) { 
    return Request.get("api/package/blacklist", toQueryStrings(data))
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
  edit(data) {
    return Request.patch(api, data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
  canceled(id) {
    return Request.delete(api + "/" + id, "")
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
  receivePackage(id) {
    return Request.put(api + "/" + id, {})
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
  finishPackage(id) {
    return Request.get("api/packages/success/", id)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
  // redir(data) {
  //   return Request.post(api + "/" + data.id, data)
  //     .then((res) => {
  //       return res;
  //     })
  //     .catch((err) => {
  //       throw err;
  //     });
  // },
  transfer(data) {
    return Request.post("api/packages/transfer", data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },

  getRouting(data) {
    return Request.get("api/packages/routing/", data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
  getShippingCost(data) {
    return Request.patch("api/model/v1/shipping/cost", data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
};
